import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeaderNotPreview";
import { ReportFacultyFeedbackApi } from "../../../service/services";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";
import { ReactComponent as BackIcon } from "../../images/pageheadingicon/backicon.svg";

function FacultyFeedbackReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Faculty Feedback Report",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/allreports",
    },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader
        exportApi={ReportFacultyFeedbackApi}
        setLoaderOpen={setLoaderOpen}
        fileName="FacultyFeedbackReport"
        reportName="FacultyFeedbackReport"
        examType="demo"
      />
    </div>
  );
}

export default FacultyFeedbackReport;
